export default __webpack_public_path__ + "static/launch-partner_misang_logo@2x-3850545cbcf0d56e870489163b35ae67.gif";